import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ILoyaltyTier } from "../../Orchestrator/Types/Interface/ICustomerTiers";
import { getRecoilStateValue, updateRecoilState } from "../../Orchestrator/Recoils/Events/Recoil";

export async function getCustomerTiers(): Promise<
  IApiResponse<{ answer: ILoyaltyTier[] }>
> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getCustomerTiers;
  return await apiRequest<{ answer: ILoyaltyTier[] }>(endpoint, "GET");
}

let _pendingTiers: Promise<ILoyaltyTier[]> | null = null;

export async function getCachedCustomerTiers(): Promise<ILoyaltyTier[]> {
  const cached = getRecoilStateValue<ILoyaltyTier[]>("loyaltyTiersAtom") as ILoyaltyTier[];
  if (cached && cached.length > 0) return cached;

  if (_pendingTiers) return _pendingTiers;

  _pendingTiers = getCustomerTiers().then(response => {
    if (response.status === "ok" && Array.isArray(response.answer)) {
      updateRecoilState<ILoyaltyTier[]>("loyaltyTiersAtom", response.answer);
      return response.answer;
    }
    // This failure raises no toast, so the console is the only signal. It is
    // forwarded to Sentry by consoleLoggingIntegration (see instrumentation-client).
    console.warn("Customer tiers unavailable; continuing without tiers", response);
    return [];
  }).finally(() => { _pendingTiers = null; });

  return _pendingTiers;
}
